import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _LabourType } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { SelectLabourTypeConstants } from './SelectLabourTypeConstants';
import { BasicButton } from '../../theme/Component/BasicButton';
import usePaginator from '../../theme/Component/usePaginator';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const SelectLabourType = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {
    const [regexStr, setregexStr] = useState<string>(null)
    const [type, settype] = useState<any>(null)
    const { instance, lista, setLista } = useDataBean(_LabourType)
    const [id, setID] = useState(null);
    const paginador = usePaginator();
    const [records, setRecords] = useState<number>(15);
    const modal = useModal("Tipo Actividad", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDLabourType == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const getLista = () => {

        instance.getLabourTypeCatalog(type, regexStr, paginador.page, records).then(
            (resp: any) => {
                if (resp) {
                    //console.log(resp.NumberOfPages)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (records ?? 15));
                    paginador.setRegiPerPage(records)

                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDLabourType', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Tipos de Labor"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">

                        <label>Búsqueda por Texto</label>
                        <input type="text" name="Name" className="form-control" value={regexStr} onChange={(e: any) => { setregexStr(e.target.value) }} />

                    </div>
                    <div className="col-md-6">
                        <SelectLabourTypeConstants idSelector={type} onChange={(e) => { settype(e) }} />

                    </div>
                    <div className="col-md-6 mt-3">
                        <BasicButton eventClick={getLista} icon="ri-folder-upload-fill" >
                            Buscar por Filtros
                        </BasicButton>
                    </div>
                </div>
                <BasicTable
                    head={head}
                    body={lista}
                    rowSet={(e) => { setValue(e.IDLabourType); modal.close(); }}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                />
            </Modal >
        </>
    )
}